import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from './ui';
import { Cookie } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'snapagent_cookie_consent';

export function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50"
        >
          <div className="bg-card border border-border rounded-xl p-5 shadow-2xl backdrop-blur-sm">
            <div className="flex items-start gap-3 mb-4">
              <Cookie className="w-5 h-5 text-accent mt-0.5 shrink-0" />
              <div>
                <p className="text-sm text-foreground font-medium mb-1">
                  {t('cookie.title')}
                </p>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {t('cookie.message')}{' '}
                  <Link to="/cookies" className="text-accent hover:underline">
                    {t('cookie.learnMore', 'Learn more about our cookie policy')}
                  </Link>
                </p>
              </div>
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="ghost" size="sm" onClick={decline}>
                {t('cookie.decline')}
              </Button>
              <Button variant="accent" size="sm" onClick={accept}>
                {t('cookie.accept')}
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
